import { SolanaWithSignerBaseCommand } from '../../../../solana';

import { web3 } from '@coral-xyz/anchor';
import { Args, Flags } from '@oclif/core';
import { Queue } from '@switchboard-xyz/on-demand';

export default class QueueSetVault extends SolanaWithSignerBaseCommand {
  static enableJsonFlag = true;

  static description = 'Set vault for queue account';

  static flags = {
    ...SolanaWithSignerBaseCommand.flags,
    vault: Flags.string({
      description: 'The vault account to set',
      required: true,
    }),
    enable: Flags.boolean({
      description: 'enable the vault',
    }),
  };

  static args = {
    queue: Args.string({
      description: 'The queue account to configure',
    }),
  };

  async run() {
    const { args, flags } = await this.parse(
      this.constructor as typeof QueueSetVault
    );

    const program = await this.program;

    const queue = new Queue(program, new web3.PublicKey(args.queue!));
    const vault = new web3.PublicKey(flags.vault!);
    const enable = flags.enable ?? false;
    const ix = await queue.setVaultIx({
      vault,
      enable,
    });

    await this.signAndSend([ix]);
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  async catch(error: any) {
    super.catch(error, 'failed to configure queue account');
  }
}
